var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { Navigation as RivendellNavigation, Separator } from '@nordlayer/rivendell-ui';
import { useFeatures } from 'flagged';
import { RegionSwitcher } from 'shared/components/RegionSwitcher';
import { useRegion } from 'shared/components/RegionSwitcher/RegionProvider';
import styled from 'styled-components';
import { useAbility } from '@nordvpn/teams.core/lib/atoms/Permissions';
import { Features } from 'types/features/enums';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { NavigationItem } from './NavigationItem';
import { UserProfileNavigationItem } from './UserProfileNavigationItem';
import { getNavigationItems } from './constants';
import { filterVisibleItems } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var RegionSwitcherContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: var(--riv-spacing-core-8) var(--riv-spacing-core-16);\n"])));
export var Navigation = function Navigation(_ref) {
    var isDesktop = _ref.isDesktop, fullName = _ref.fullName;
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var isUsersManagementEnabled = useFeatureFlag(Features.UsersManagement);
    var isDistributorsEnabled = useFeatureFlag(Features.Distributors);
    var isRegionSwitcherEnabled = useFeatureFlag(Features.MultiRegionSwitcher);
    var isOrganizationsRedesignEnabled = useFeatureFlag(Features.OrganizationsRedesign);
    var features = useFeatures();
    var ability = useAbility();
    var region = useRegion();
    var shouldRenderRedesignedUsersManagement = areFeaturesLoaded && isUsersManagementEnabled;
    var shouldRenderDistributors = areFeaturesLoaded && isDistributorsEnabled;
    var shouldRenderRedesignedOrganizations = areFeaturesLoaded && isOrganizationsRedesignEnabled;
    var navigationItems = filterVisibleItems(getNavigationItems(shouldRenderRedesignedUsersManagement, shouldRenderDistributors, shouldRenderRedesignedOrganizations), features, ability, region);
    return /*#__PURE__*/ _jsxs(RivendellNavigation, {
        children: [navigationItems.map(function (item, index) {
                return /*#__PURE__*/ _jsx(NavigationItem, {
                    item: item
                }, index);
            }), !isDesktop && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [/*#__PURE__*/ _jsx(Separator, {}), isRegionSwitcherEnabled && /*#__PURE__*/ _jsx(RegionSwitcherContainer, {
                        children: /*#__PURE__*/ _jsx(RegionSwitcher, {})
                    }), /*#__PURE__*/ _jsx(UserProfileNavigationItem, {
                        fullName: fullName
                    })]
            })]
    });
};
